module.exports = {
      id: "filter-icon-usage",
      viewBox: "0 0 13 14",
      url: "/" + "sprite-6d93c42890617d6f6477c703e3b36dd9.svg#filter-icon",
      toString: function () {
        return this.url;
      }
    }